// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"15024ec3","232":"c1a0e999","237":"29ce3e2b","357":"8b4f196e","526":"6598d392","872":"09e90c32"}[chunkId] + ".chunk.js";
};